module.exports = __webpack_public_path__ + "static/media/biopic.57a2a67e.jpeg";